import { TrackJS } from 'trackjs';

type ConsoleArgs = Parameters<typeof console.info>;

export const log = {
  info: (...args: ConsoleArgs) => {
    if (TrackJS.isInstalled()) {
      TrackJS.console.info(...args);
    } else {
      // oxlint-disable-next-line no-console
      console.info(...args);
    }
  },
  error: (...args: ConsoleArgs) => {
    if (TrackJS.isInstalled()) {
      TrackJS.console.error(...args);
    } else {
      // oxlint-disable-next-line no-console
      console.error(...args);
    }
  },
};
